<script setup lang="ts">
import { computed } from 'vue';
import { savedViewIconFor, savedViewTintFor, type SavedViewAppearance } from '@/utils/savedViewAppearance';

/**
 * A saved view's icon in its colour. A view with no choice of its own shows the
 * lime bookmark every view used to show.
 *
 * The span carries the size and the test ids. The heroicons are functional
 * components, which pass on only class, style and listeners, so a test id put
 * on the svg itself would be dropped.
 */
const props = defineProps<{ appearance?: SavedViewAppearance | null }>();

const icon = computed(() => savedViewIconFor(props.appearance));
const tint = computed(() => savedViewTintFor(props.appearance));
</script>

<template>
  <span
    :class="['inline-flex shrink-0', tint]"
    aria-hidden="true"
    data-testid="saved-view-icon"
    :data-icon="appearance?.icon ?? 'bookmark'"
  >
    <component :is="icon" class="size-full" />
  </span>
</template>
